const Api = {
    "login": "systemUser/login"
}
export default Api;
